import { useScrollStore, useThemeStore } from '../../libs/stores';
import { useEffect } from 'react';

export default function StoreComponent() {
  const getThemeFromLocalStorage = useThemeStore((state) => state.getThemeFromLocalStorage)
  const updateScrollBarWidth = useScrollStore(state => state.updateScrollBarWidth)
  const setScrollPosition = useScrollStore(state => state.setScrollPosition)
  const theme = useThemeStore((state) => state.isDarkTheme())

  useEffect(() => {
    // console.log("Updating Stores")

    getThemeFromLocalStorage();
    updateScrollBarWidth();

    function handleScroll () {
      setScrollPosition(document.body.scrollTop)
    }

    let interval = setInterval(() => {
      updateScrollBarWidth();
    }, 200);

    document.body.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      document.body.removeEventListener("scroll", handleScroll);
      clearInterval(interval);
    }
  }, [getThemeFromLocalStorage, updateScrollBarWidth, setScrollPosition]);

  useEffect(() => {
    if (theme) {
      document.body.classList.add("theme-dark");
    } else {
      document.body.classList.remove("theme-dark");
    }
  }, [theme]);

  return "";
}